import { Entity } from '@/store/shared/entity'
export default class SystemCode extends Entity<number>{
    category:string;
    code:string;
    codeDescription_zh:string;
    codeDescription_en:string;
    sequenceNo:string;
    additionValue:string;
}